import script from "./ManagerRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagerRegister.vue?vue&type=script&setup=true&lang=js"

import "./ManagerRegister.vue?vue&type=style&index=0&id=9f31085a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f31085a"]])

export default __exports__